import './paged-list.scss';

export default {
  table: "table table-striped",
  pagination: "pagination-display",
  perPage: "per-page-dropdown form-inline",
  dropdown: "form-control",
  pagingControls: "paging-controls"
}



// WEBPACK FOOTER //
// src/common/paged-list.style.js